import { RoomControl } from '@/client/controls/roomControl';
import { LongSoundEfx } from '@/client/sound/LongSoundEfx';
import { SpecialSkill, specialSkillInfos } from '@/game/infos/skills';
import { MiscData, MiscDataBiAtomBomb, MiscDataSsSunPunch } from '@/game/multithread/skills/miscContainer';
import { MyData } from '@/game/multithread/state';
import { ViewState } from '@/game/multithread/viewState';
import { ManualTween } from '@/util/animatingVertices';
import { Rotate } from '@/util/rotate';
import { Ease, Tween } from '@/util/tweents';
import { Container, Graphics, Sprite } from 'pixi.js';
import Factory from '../../..';
import { MiscSymbol } from '../../skills/miscSymbol';
import { MovieClip } from 'pixi-animate';
import { Pool } from '@/util/pool';
import { SsSunPunchSymbol } from '../../skills/ssSunPunchSymbol';

export class MechguinAtomExplosion extends MovieClip {
	public init() {
		this.children[1].mask = this.children[2].mask = this.children[3].mask = this.children[4].mask = (this.children[5] as Sprite);
	}
}
export class BiAtomBombController implements MiscSymbol {

	public static get() {
		return BiAtomBombController._pool.get();
	}

	private static _pool: Pool<BiAtomBombController> = new Pool(BiAtomBombController);


	public data: MiscData | null = null;
	public pt = 0;

	public sound = new LongSoundEfx('sunPunch');
	public symbol = Factory.get(MechguinAtomExplosion);


	public constructor() {
	}
	public dispose(room: RoomControl) {
		this.data = null;
		Tween.get(this.symbol).to({ alpha: 0 }, 300).call(() => {
			if (this.symbol.parent) {
				this.symbol.parent.removeChild(this.symbol);
			}
			BiAtomBombController._pool.pool(this);
		});
		Tween.get(this.sound).to({ volume: 0 }, 500).call(() => {
			this.sound.stop();
		});
	}
	public update(room: RoomControl, dt: MiscData, rt: number, state: ViewState) {
		const data = dt as MiscDataBiAtomBomb;

		this.symbol.x = data.x;
		this.symbol.y = data.y;
		this.symbol.scale.set(data.sc / 4);


		if (!this.data) {
			this.symbol.alpha = 0.8;
			this.sound.start();
			room.cameraControl.swing(8, 6000);
		}
		this.data = data;

		const volume = (2000 - Rotate.dist(data.x, data.y, state.x, state.y)) / 2000;
		this.sound.volume = volume;
	}
	public show(room: RoomControl) {
		room.playerTopContainer.addChild(this.symbol);
	}
	public hide(room: RoomControl) {
		if (this.symbol.parent) {
			this.symbol.parent.removeChild(this.symbol);
		}
		this.sound.volume = 0;
	}
}
